import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "tab-progression ma-0 full-width" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxStage, (i) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          key: i,
          class: _normalizeClass([{full: i <= _ctx.stage}, "tab pa-0"])
        }, null, 8, ["class"]))
      }), 128))
    ]),
    _: 1
  }))
}